module.exports = "- Use Text to display read-only text that inherits styling from ITheme.\n"